export default "__VITE_ASSET__wIJhDh_n__"